import {
    CREATE_WORKER_UPAD,
    DELETE_WORKER_UPAD,
    GET_WORKER_UPAD,
    WORKER_UPAD_REQUEST,
    WORKER_UPAD_REQUEST_FAILURE,
    UPDATE_WORKER_UPAD
  } from "../types/worker-upad-types";
  
  const initialState = {
    workerUpad: [],
    loading: false,
    error: null,
  };

  const workerUpadReducer = (state = initialState, action) => {
    switch (action.type) {
      case WORKER_UPAD_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_WORKER_UPAD: {
        return {
          ...state,
          workerUpad: [...action.payload],
          loading: false,
          error: null
        }
      }
      case CREATE_WORKER_UPAD:
        return {
          ...state,
          workerUpad: [action.payload, ...state.workerUpad],
          loading: false,
          error: null
        };
      case UPDATE_WORKER_UPAD:
        const workerUpadData = state.workerUpad.slice(0);
        console.log('before>>', workerUpadData);
        const uIndex = workerUpadData.findIndex((data) => data.id === action.payload.id);
        console.log('uIndex>>', uIndex);
        workerUpadData.splice(uIndex, 1, { ...action.payload.data });
        console.log('after>>', workerUpadData.splice(uIndex, 1, { ...action.payload.data }));
        
        return {
          ...state,
          workerUpad: [ ...workerUpadData ],
          loading: false,
          error: null
        };
      case DELETE_WORKER_UPAD:
        const workerUpad = state.workerUpad?.slice(0);
        const index = workerUpad.findIndex((data) => data.id === action.id);
        if (index > -1) {
          workerUpad.splice(index, 1);
        }
        return {
          ...state,
          workerUpad: [...workerUpad],
          loading: false,
          error: null
        }
      case WORKER_UPAD_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };

  export default workerUpadReducer;
  